export function getTimerLabel(time) {
  const seconds = Math.floor(time / 1000);
  const milliseconds = Math.floor((time % 1000) / 10); // ミリ秒を2桁で表示
  const ms = milliseconds < 10 ? `0${milliseconds}` : milliseconds // 0パディング
  return `${seconds}:${ms}`;
}
